import * as React from 'react';

import { IStyleConfig, mergeStyles } from '@cian/components';

const style = require('./index.css');

export type ButtonLikeElement = React.ReactElement<{
  buttonStyle: IStyleConfig;
}>;

type TChild = ButtonLikeElement | null | undefined | boolean;

export interface IButtonGroupProps {
  children?: TChild | TChild[];
  className?: string;
}

export class ButtonGroup extends React.Component<IButtonGroupProps> {
  public render() {
    const buttons = this.renderButtons();

    if (!buttons.length) {
      return null;
    }

    return <div {...mergeStyles([style.container, this.props.className])}>{buttons}</div>;
  }

  private renderButtons(): JSX.Element[] {
    const filtered = React.Children.toArray(this.props.children).filter(e => !!e && typeof e !== 'string');

    return filtered.map((child: ButtonLikeElement, index: number) => {
      const buttonStyle = this.getButtonStyle(index, filtered.length);
      const mergedStyle = mergeStyles(child.props.buttonStyle, style['button'], buttonStyle);

      return React.cloneElement(child, {
        buttonStyle: [mergedStyle.className, mergedStyle.style] as IStyleConfig,
      });
    });
  }

  private getButtonStyle = (index: number, total: number): React.CSSProperties | undefined => {
    if (total === 1) {
      return undefined;
    }

    switch (index) {
      case 0:
        return style['button--first'];
      case total - 1:
        return style['button--last'];
      default:
        return style['button--middle'];
    }
  };
}
